import React, { useMemo, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import ArticleCard from '../components/ArticleCard';
import useNews from '../hooks/useNews';

const { FiSearch } = FiIcons;
const filters = [
  'All',
  'Latest',
  'Most Read',
  'News',
  'Asia',
  'Europe',
  'Sport',
  'Business',
  'Technology',
  'Health',
  'Culture',
  'Arts',
  'Travel',
  'Earth'
];

function Search() {
  const [query, setQuery] = useState('');
  const [filter, setFilter] = useState('All');
  const { articles } = useNews({ limit: 250 });

  const results = useMemo(() => {
    const filtered = articles.filter((article) => {
      const searchContent = [
        article.title,
        article.excerpt,
        article.author,
        article.category,
        article.label,
        article.source
      ].join(' ').toLowerCase();

      const matchesQuery = searchContent.includes(query.toLowerCase());
      const matchesFilter = ['All', 'Latest', 'Most Read', 'News'].includes(filter)
        || article.category === filter;

      return matchesQuery && matchesFilter;
    });

    if (filter === 'Most Read') {
      return filtered.sort(
        (a, b) => (b.viewCount || 0) - (a.viewCount || 0)
      );
    }

    return filtered;
  }, [articles, query, filter]);

  return (
    <div className="shell page-space search-page">
      <header className="page-header">
        <span className="eyebrow">DISCOVER</span>
        <h1>Search Opiniguru</h1>
      </header>
      <div className="search-box">
        <SafeIcon icon={FiSearch} />
        <input
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="Search headlines, authors, categories and sources"
          autoFocus
        />
      </div>
      <div className="filter-row">
        {filters.map((item) => (
          <button
            className={filter === item ? 'active' : ''}
            onClick={() => setFilter(item)}
            key={item}
          >
            {item}
          </button>
        ))}
      </div>
      <p className="result-count">
        {results.length} results {query && `for “${query}”`}
      </p>
      <div className="search-results">
        {results.map((article) => (
          <ArticleCard key={article.id} article={article} horizontal />
        ))}
      </div>
    </div>
  );
}

export default Search;